import { AppError } from './app.error';

export class MediaError extends AppError {
    constructor(message: string) {
        super(message);
    }
}
